import React from 'react'

export default function ReferateProprii() {
    return (
        <div>
            referate proprii
        </div>
    )
}
